import React, { Component, useState, useEffect, useRef } from 'react';




const Biodatafaculty = (props) => {
    console.log("props",props);
    
    return (
            <div>
                <div className='tab-cont'>             
                  <div className="wrp-biodata">
                     <div
  className="wrp-biodata faculty-content"
  dangerouslySetInnerHTML={{ __html: props.bio }}
/>

                  </div>
                </div>
            </div>
    );
}


export default Biodatafaculty;

